import React from 'react';
import { Link } from 'gatsby';
import { ThemeProvider } from 'styled-components';
import OImage from '../OImage';
import Wysiwyg from '../Wysiwyg';
import CoverImage from '../../ui/CoverImage';

import Wrapper from '../../ui/Wrappers';
import { themes } from '../../ui/design-tokens';

import { Module, ContentZone, Container, TextZone, ImageZone } from './styles';
import { ButtonSmall } from '../../ui/Button';
import { getSrcset, externalLink } from '../../ui/helpers';

interface IProps {
  theme?: string;
  heading?: string;
  title?: string;
  subtitle?: string;
  direction: string;
  text: string;
  link?: { uri: string; title: string };
  imageUrl: any;
  imageAlt?: string;
  gtmAction?: string;
  isShop?: boolean;
  isActivities?: boolean;
  isAcademy?: boolean;
  isFranchises?: boolean;
  isCoverImage?: boolean;
  imgFullBackground?: boolean;
}

const HomeImageText = ({
  theme,
  heading,
  title,
  subtitle,
  direction,
  text,
  link,
  imageUrl,
  imageAlt,
  gtmAction,
  isShop = false,
  isActivities = false,
  isAcademy = false,
  isFranchises = false,
  isCoverImage = false,
  imgFullBackground = false
}: IProps) => {
  const cleanedTheme = theme ? theme : 'neutral_black';
  const isGradient = cleanedTheme.endsWith('_gradient');
  const classes = [];

  if (imgFullBackground) classes.push('imgFullBackground');
  if (isActivities) classes.push('activities');
  if (isAcademy) classes.push('academy');
  if (isShop) classes.push('shop');
  if (isFranchises) classes.push('franchises');
  if (isCoverImage) classes.push('is-cover-image');

  return (
    <ThemeProvider theme={themes[isGradient ? 'gradients' : 'basic'][cleanedTheme]}>
      <Module
        style={imgFullBackground ? { backgroundImage: 'url(' + imageUrl?.original?.href.replace(/ /g, '%20') + ')' } : undefined}
        gradient={isGradient}
        className={classes.join(' ')}>
        <Wrapper fullwidth={true} as={Container} size="mainwrapper">
          <Wrapper fullwidth={true} as={ContentZone} className={`${direction === 'text_right' ? 'reverse' : ''}`} style={{ backdropFilter: gtmAction === 'academias' ? 'grayscale(100%)' : 'none', height: (isActivities ? 'fit-content' : '') }}>
            {imgFullBackground && (
              <div className={'imgMobile'}>
                <ImageZone>
                  {imageUrl && (
                    <OImage
                      src={imageUrl.original?.href}
                      aspectRatio={imageUrl.original?.meta.width / imageUrl.original?.meta.height}
                      srcSet={getSrcset(imageUrl)}
                      webp={getSrcset(imageUrl, true)}
                      alt={imageAlt || ''}
                      className="image"
                    />
                  )}
                </ImageZone>
              </div>
            )}
            <TextZone isShop={isShop}>
              {subtitle && <p className={'subtitle'}>{subtitle}</p>}
              {title &&
                (heading === 'heading_2' ? (
                  <h2 className="title">{title}</h2>
                ) : (
                  <h3 className="title">{title}</h3>
                ))}
              <Wysiwyg className="text" text={text} />
              {link && link?.uri && (
                <div className="ctaContainer">
                  <ButtonSmall
                    as={externalLink(link.uri) ? 'a' : Link}
                    className="btn"
                    href={externalLink(link.uri) ? link.uri : null}
                    to={externalLink(link.uri) ? null : link.uri}
                    target={externalLink(link.uri) && '_blank'}
                    rel={externalLink(link.uri) && 'nofollow noopener noreferrer'}
                    secondary={1}
                    data-gtm-event
                    data-gtm-category="cta"
                    data-gtm-action={gtmAction}
                    data-gtm-label={`${link.title}_${link.uri}`}>
                    {link.title}
                  </ButtonSmall>
                </div>
              )}
              {link && link?.uri && isShop && (
                <div className="shopCta">
                  <ButtonSmall
                    as={externalLink(link.uri) ? 'a' : Link}
                    className="btn"
                    href={externalLink(link.uri) ? link.uri : null}
                    to={externalLink(link.uri) ? null : link.uri}
                    target={externalLink(link.uri) && '_blank'}
                    rel={externalLink(link.uri) && 'nofollow noopener noreferrer'}
                    secondary={1}
                    data-gtm-event
                    data-gtm-category="cta"
                    data-gtm-action={gtmAction}
                    data-gtm-label={`${link.title}_${link.uri}`}>
                    {link.title}
                  </ButtonSmall>
                </div>
              )}
            </TextZone>
            {!imgFullBackground && (
              <ImageZone>
                {imageUrl && isCoverImage && (
                  <CoverImage img={imageUrl.original?.href} className="cover-image" />
                )}

                {imageUrl && (
                  <OImage
                    src={imageUrl.original?.href}
                    aspectRatio={imageUrl.original?.meta.width / imageUrl.original?.meta.height}
                    srcSet={getSrcset(imageUrl)}
                    webp={getSrcset(imageUrl, true)}
                    alt={imageAlt || ''}
                    className={"image " + (isActivities ? 'image-adjust' : '')}
                  />
                )}
              </ImageZone>
            )}
          </Wrapper>
        </Wrapper>
      </Module>
    </ThemeProvider>
  );
};

export default HomeImageText;
